import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import React, { useRef } from 'react';

const ResizablePaper = styled(Paper)(() => ({
  resize: 'both',
  overflow: 'auto',
  minWidth: 640,
  minHeight: 200,
  maxWidth: '94vw',
  maxHeight: '94vh',
  width: '90vw',
}));

function DraggableResizablePaper(props) {
    const nodeRef = useRef(null);
    const handleId = props['aria-labelledby'] ? `#${props['aria-labelledby']}` : '#customReactDraggableComponent';
    return (
    <Draggable
      nodeRef={nodeRef}
      bounds={"parent"}
      defaultClassName="customReactDraggableComponent"
      handle={handleId}
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <ResizablePaper 
      ref={nodeRef} {...props} />
    </Draggable>
    )
}

export default DraggableResizablePaper;
